import { Spinner as HeroSpinner } from '@heroui/react';
import { FC } from 'react';

import { SpinnerWrapper } from './styles';

export type SpinnerProps = {
  global?: boolean;
  showLabel?: boolean;
}

export const Spinner: FC<SpinnerProps> = ({ global = false, showLabel }) => (
  <SpinnerWrapper data-testid="spinner" global={global}>
    <HeroSpinner label={showLabel ? 'Loading data...' : ''} variant="spinner" size="sm" color="secondary" />
  </SpinnerWrapper>
);
